import { type FC } from 'react'
import { useZohoContactSync } from '../IntegrationSpecificSettings/Zoho/hooks'
import { type CrmIntegrationSettings, type CrmSettingsProviderProps } from './types'

export const ZohoCrmSettingsProvider: FC<CrmSettingsProviderProps> = ({ children }) => {
  const contact = useZohoContactSync()

  const settings: CrmIntegrationSettings = {
    contactSync: contact.autoSync ?? false,
    calendarSync: false,
    isSyncDisabled: contact.isSyncDisabled,
    isFetching: contact.isFetching,
    isSaving: contact.isSaving,
    save: async (patch) => {
      if (patch.contactSync !== undefined) {
        await contact.saveAutoSync(patch.contactSync)
      }
    },
  }

  return <>{children(settings)}</>
}
